export function whichHour(): string {
  const hours = new Date().getHours();
  if (hours < 12) return 'Morning';
  if (hours >= 12 && hours < 17) return 'Afternoon';
  return 'Evening';
}

export function cashFormater(cash: any) {
  cash += '';
  const indexOfDecimal = cash.indexOf('.');

  cash = cash.substr(indexOfDecimal).length > 3 ? cash.substr(0, indexOfDecimal + 3) : cash;
  cash += cash.indexOf('.') === -1 ? '.00' : '';
  cash = cash.substr(cash.indexOf('.')).length === 2 ? `${cash}0` : cash;
  return cash
    .replace(/(\d((?=(.{3})+$)))/g, '$1,')
    .replace(/,\./, '.')
    .replace('.00', '');
}

export function getMobileOS(): 'iOS' | 'Android' | 'Windows' | 'macOS' | 'Linux' | 'unknown' {
  const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
  const platform = typeof window !== 'undefined' ? window.navigator.platform : '';

  if (/android/i.test(userAgent)) return 'Android';
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any)?.MSStream) return 'iOS';
  if (/Win/.test(platform)) return 'Windows';
  if (/Mac/.test(platform)) return 'macOS';
  if (/Linux/.test(platform)) return 'Linux';

  return 'unknown';
}